<template>
  <div>
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="项目名称:" prop="strDocumentTitle">
        <el-select
          v-model.trim="searchForm.strDocumentTitle"
          filterable
          remote
          reserve-keyword
          placeholder="请输入项目名称"
          :remote-method="remoteMethod"
          :loading="loading"
        >
          <el-option
            v-for="item in projectOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :loading="loading"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="销售人员:" prop="strSaleName">
        <el-input v-model.trim="searchForm.user" placeholder="请输入销售人员姓名" />
      </el-form-item>
      <el-form-item label="最终客户:" prop="strCRMAccountName">
        <el-input v-model.trim="searchForm.strCRMAccountName" placeholder="请输入最终客户名称" />
      </el-form-item>
      <el-form-item label="订单时间:" prop="strStartTime">
        <div class="rj-flex" style="width:260px;">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.strStartTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.strEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>
      <!--<el-form-item label="流程分类:">-->
      <!--<el-select placeholder="请选择" v-model="searchForm.orderType" clearable>-->
      <!--<el-option v-for="option in orderProcessType" :label="option.name" :value="option.code" :key="option.code" />-->
      <!--</el-select>-->
      <!--</el-form-item>-->
      <el-form-item>
        <el-button type="primary" :loading="isEcpLoading && isOpLoading" @click="doSearch">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <div v-loading="isOpLoading" class="tableBody">
      <el-button type="default" style="margin-bottom: 10px" :loading="submitLoading" @click="exportAllNotDelivered">
        导出欠货报表
      </el-button>
      <div class="table-title">
        新下单系统单据
      </div>
      <el-table :data="opTableData" border style="width: 100%">
        <el-table-column prop="oppName" label="项目名称" align="left" fixed="left">
          <template v-slot="{row}">
            <span class="linkName" @click="goOrderInfo(row, 1)">{{ row.oppName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="flowClass" label="流程分类" align="left" width="130" />
        <el-table-column prop="integratorsPriceTotal" label="集成商总价(元)" align="right" header-align="left" width="160">
          <template v-slot="{row}">
            <span v-if="row.flowClass==='确认服务主体'">--</span>
            <span v-else>{{ row.integratorsPriceTotal }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="salesmanName" label="销售人员" align="left" width="90" />
        <el-table-column prop="crmAccountName" label="最终客户名称" align="left" />
        <el-table-column label="流程状态" align="left">
          <template v-slot="{row}">
            <!-- <el-button type="text" @click="statusName(row.documentID)">查看</el-button> -->
            <span>{{ row.stateName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="stateDateTime" label="订单时间" align="left" width="150" />
        <el-table-column label="物流" width="70" align="left" fixed="right">
          <template v-slot="{row}">
            <!--            是否分销商参与 如果分销商参与 可以跳转，没有分销商参与，在合同中可以查看物流-->
            <el-button v-if="row.distributorParticipate" type="text" @click="LookLogistics(row)">
              查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="办理过程" width="90" align="left" fixed="right">
          <template v-slot="{row}">
            <el-button type="text" @click="getProcessInfoList(row.documentID)">
              操作
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="操作" width="120" align="left" fixed="right">
          <template v-slot="{row}">
            <el-button v-if="row.fpfhFlag" type="text" @click="partShip(row)">
              申请分批发货
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[5, 10, 20, 30, 40]"
          :page-size.sync="opPage.pageSize"
          :current-page.sync="opPage.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="opPage.total"
          hide-on-single-page
          @size-change="handerSizeChangeOp"
          @current-change="currentChangeOp"
        />
      </div>
    </div>

    <div v-loading="isEcpLoading" class="tableBody">
      <div class="table-title">
        原下单系统单据
      </div>
      <el-table :data="ecpTableData" border style="width: 100%">
        <el-table-column prop="oppName" label="项目名称" align="left" fixed="left">
          <template v-slot="{row}">
            <span class="linkName" @click="goOrderInfo(row, 0)">{{ row.oppName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="flowClass" label="流程分类" align="left" width="130" />
        <el-table-column prop="integratorsPriceTotal" label="集成商总价(元)" align="right" header-align="left" width="160">
          <template v-slot="{row}">
            <span v-if="row.flowClass==='确认服务主体'">--</span>
            <span v-else>{{ row.integratorsPriceTotal }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="salesmanName" label="销售人员" align="left" width="90" />
        <el-table-column prop="crmAccountName" label="最终客户名称" align="left" />
        <el-table-column label="流程状态" align="left" fixed="right">
          <template v-slot="{row}">
            <el-button type="text" @click="statusName(row.documentID)">
              查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="stateDateTime" label="订单时间" align="left" width="150" />
        <el-table-column label="物流" width="70" align="left" fixed="right">
          <template v-slot="{row}">
            <!--            是否分销商参与 如果分销商参与 可以跳转，没有分销商参与，在合同中可以查看物流-->
            <el-button v-if="row.distributorParticipate" type="text" @click="LookLogistics(row)">
              查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="办理过程" width="90" fixed="right" align="left">
          <template v-slot="{row}">
            <el-button type="text" @click="getProcessInfoList(row.documentID)">
              操作
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="操作" width="120" fixed="right" align="left">
          <template v-slot="{row}">
            <el-button v-if="row.fpfhFlag" type="text" @click="partShip(row)">
              申请分批发货
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin: 10px 0">
        <el-pagination
          :page-sizes="[5, 10, 20, 30, 40]"
          :page-size.sync="ecpPage.pageSize"
          :current-page.sync="ecpPage.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="ecpPage.total"
          hide-on-single-page
          @size-change="handerSizeChangeEcp"
          @current-change="currentChangeEcp"
        />
      </div>
    </div>

    <el-dialog title="办理过程" :visible.sync="ProcessingVisible" width="420px">
      <div v-loading="ProcessingLoading">
        <rj-timeline v-if="ProcessingList.length" class="Processing">
          <rj-timeline-item v-for="(pro,index) in ProcessingList" :key="index" :color="index ? '#909399':''">
            <p>{{ pro.processDescribe }}</p>
            <p>{{ pro.createTime }}</p>
          </rj-timeline-item>
        </rj-timeline>
        <div v-else-if="!ProcessingLoading" style="font-size: 15px;text-align: center;padding: 20px">
          暂无数据...
        </div>
      </div>
    </el-dialog>
    <el-dialog title="流程状态" :visible.sync="StatusVisible" width="800px" @close="closeStatus">
      <div v-loading="StatusLoading">
        <rj-timeline v-if="StatusList.length" class="Processing">
          <el-table :data="StatusList" border style="width: 100%" :row-class-name="tableRowClassName">
            <el-table-column label="节点位置" align="left">
              <template v-slot="{row}">
                <span v-if="row.wfStates =='待办'">当前节点</span>
                <span v-else>历史节点</span>
              </template>
            </el-table-column>
            <el-table-column prop="wfRemark" label="节点名称" align="left" />
            <el-table-column prop="executorName" label="审批人" align="left" width="200" />
            <el-table-column prop="wfStates" label="审批状态" align="left" />
            <el-table-column prop="approvedDateTime" label="审批时间" align="left" width="200" />
          </el-table>
        </rj-timeline>
        <div v-else-if="!StatusLoading" style="font-size: 15px;text-align: center;padding: 20px">
          暂无数据...
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script type="es6">
import { mapState, mapActions } from 'vuex';
import timeLine from 'rjelement-components/packages/components/timeLine';
import timeLineItem from 'rjelement-components/packages/components/timeLineItem';
import { getExportAgentAgreedDeliveryDate, getAlreadyDoneOrderList, getProcessInfoList, getContractInfoByDocumentId, getAutoDocumentTitle, getOrderApprovalWorkFlow } from '../../../API/index';
import eventBus from '@/libs/eventBus';
export default {
  components: {
    'rj-timeline': timeLine,
    'rj-timeline-item': timeLineItem
  },

  data () {
    return {
      searchForm: {
        strDocumentTitle: '',
        strSaleName: '',
        strStartTime: '',
        strEndTime: '',
        strCRMAccountName: ''
      },

      isEcpLoading: false,
      isOpLoading: false,
      ecpTableData: [],
      opTableData: [],

      ecpPage: {
        pageSize: 5,
        total: 0,
        currentPage: 1
      },
      opPage: {
        pageSize: 5,
        total: 0,
        currentPage: 1
      },

      submitLoading: false,
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.strStartTime) {
            return time.getTime() <= (new Date(this.searchForm.strStartTime)).getTime();
          }
          return false;
        }
      },
      StatusVisible: false,
      StatusLoading: false,
      StatusList: [], // 流程数据
      ProcessingVisible: false,
      ProcessingLoading: false,
      ProcessingList: [],
      needLoadData: false,
      projectOptions: [],
      pOptions: [],
      loading: false
    };
  },

  computed: {
    ...mapState({
      orderProcessType: state => state.enumeration.orderProcessType
    })
  },

  watch: {
    ProcessingVisible (val) {
      if (!val) {
        this.$nextTick(() => {
          this.ProcessingList = [];
        });
      }
    }
  },

  mounted () {
    this.initOrderProcessType();
    this.doSearch();
    this.getProjectTitle();

    eventBus.$on('CompleteChiefOrder', () => {
      this.resetForm();
      this.needLoadData = true;
    });
  },

  activated () {
    if (this.needLoadData) {
      this.doSearch();
    }
  },

  destroyed () {
    eventBus.$off('CompleteChiefOrder');
  },

  methods: {
    ...mapActions('enumeration', ['initOrderProcessType']),

    exportAllNotDelivered () {
      this.submitLoading = true;
      getExportAgentAgreedDeliveryDate().then((res) => {
        this.submitLoading = false;
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        const fileName = '欠货报表' + new Date().toLocaleString() + '.xlsx';
        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch(() => {
        this.submitLoading = false;
      });
    },

    queryOldEcpData () {
      let params = {
        ...this.searchForm,
        pageIndex: this.ecpPage.currentPage - 1,
        pageSize: this.ecpPage.pageSize,
        strAgentId: this.$store.state.user.userId,
        newEcpFlag: 0
      };
      this.isEcpLoading = true;

      getAlreadyDoneOrderList(params)
        .then((res) => {
          this.isEcpLoading = false;
          let { status, data } = res.data;
          if (status === '200') {
            this.ecpTableData = data.dt || [];
            this.ecpPage.total = data.totalCount;
          }
        }).catch(() => {
          this.isEcpLoading = false;
        });
    },

    queryOpData () {
      let params = {
        ...this.searchForm,
        pageIndex: this.opPage.currentPage - 1,
        pageSize: this.opPage.pageSize,
        strAgentId: this.$store.state.user.userId,
        newEcpFlag: 1
      };
      this.isOpLoading = true;

      getAlreadyDoneOrderList(params)
        .then((res) => {
          this.isOpLoading = false;
          let { status, data } = res.data;
          if (status === '200') {
            this.opTableData = data.dt || [];
            this.opPage.total = data.totalCount;
          }
        }).catch(() => {
          this.isOpLoading = false;
        });
    },

    doSearch () {
      this.queryOldEcpData();
      this.queryOpData();
    },

    tableRowClassName ({ row }) {
      if (row.wfStates === '待办') {
        return 'color-red';
      }
    },

    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchForm.strEndTime = '';
      this.page.currentPage = 1;
      this.doSearch();
    },

    // 改变每页条数 当前页回到第一页
    handerSizeChangeEcp (val) {
      this.ecpPage.currentPage = 1;
      this.queryOldEcpData();
    },

    // 改变当前页
    currentChangeEcp (val) {
      this.ecpPage.currentPage = val;
      this.queryOldEcpData();
    },

    // 改变每页条数 当前页回到第一页
    handerSizeChangeOp (val) {
      this.opPage.currentPage = 1;
      this.queryOpData();
    },

    // 改变当前页
    currentChangeOp (val) {
      this.opPage.currentPage = val;
      this.queryOpData();
    },

    statusName (documentID) {
      if (!documentID) {
        return;
      }
      this.StatusVisible = true;
      this.StatusLoading = true;
      getOrderApprovalWorkFlow(documentID).then((res) => {
        let json = res.data;
        this.StatusLoading = false;
        if (json.status === '200') {
          this.StatusList = json.data;
        }
      }).catch(() => {
        this.StatusLoading = false;
      });
    },
    closeStatus () {
      this.StatusList = [];
    },
    LookLogistics (row) {
      // 查看物流跳转判断。 如果存在 跳转否则提示
      getContractInfoByDocumentId(row.documentID).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          if (json.data) {
            this.$router.push({
              name: 'logistics',
              params: {
                contractNum: json.data.contractNum
              },
              query: { id: json.data.id, masterProjectName: json.data.projectName }
            });
          } else {
            this.$notify.error({
              message: '暂未生成合同，请稍后再试。'
            });
          }
        }
      }).catch(() => {

      });
    },
    partShip (row) {
      getContractInfoByDocumentId(row.documentID).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          if (json.data.contractNum) {
            this.$router.push({
              name: 'logistics',
              params: {
                contractNum: json.data.contractNum
              },
              query: {
                id: json.data.id,
                masterProjectName: json.data.projectName,
                transact: '1',
                distributeContractTypeFlag: row.distributeContractTypeFlag ?? false
              }
            });
          } else {
            this.$notify.error({
              message: '暂未生成合同，请稍后再试。'
            });
          }
        }
      }).catch(() => {

      });
    },
    getProcessInfoList (documentID) {
      if (!documentID) {
        return;
      }
      this.ProcessingVisible = true;
      this.ProcessingLoading = true;
      getProcessInfoList(documentID).then((res) => {
        let json = res.data;
        this.ProcessingLoading = false;
        if (json.status === '200') {
          this.ProcessingList = json.data;
        }
      }).catch(() => {
        this.ProcessingLoading = false;
      });
    },
    goOrderInfo (row, newEcpFlag) {
      if (row.flowClass !== '确认服务主体') {
        this.$router.push({
          name: 'ChiefOrderPriceInfo',
          query: { newEcpFlag },
          params: { documentID: row.documentID }
        });
      } else {
        this.$router.push({
          name: 'ChiefOrderSubjectInfo',
          query: { newEcpFlag },
          params: { documentID: row.documentID }
        });
      }
    },
    getProjectTitle () {
      getAutoDocumentTitle(this.searchForm.strDocumentTitle).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.pOptions = json.data;
          this.projectOptions = this.pOptions.map(item => {
            return { value: item, label: item };
          });
        }
      }).catch((res) => {

      });
    },
    remoteMethod (query) {
      if (query !== '') {
        getAutoDocumentTitle(query).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.pOptions = json.data;
            this.projectOptions = this.pOptions.map(item => {
              return { value: item, label: item };
            });
          }
        }).catch((res) => {

        });
      }
    }
  }
};
</script>

<style lang="scss">
  @import "../../../style/var";
  .linkName{
    color: $--color-primary;
    cursor: pointer;
  }
  .Processing{
    p{
      margin-bottom: 6px;
    }
    .rj-timeline-item__tail{
      top: 6px;
    }
    .rj-timeline-item{
      padding: 0 0 5px;
      .rj-timeline-item__content{
        color: $--color-text-secondary;
      }
      &:first-child{
        .rj-timeline-item__content{
          color: $--color-primary;
        }
      }
    }
  }

.table-title{
  padding-bottom: 4px;
  color: #606266;
  font-size: 16px;
}
</style>
